<script setup lang="ts">
const toast = useToast()
import { onMounted, watch } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useSettingsStore } from '@/stores/settings'
import { useColorMode } from '@vueuse/core'

useColorMode().value = 'light'

const auth = useAuthStore()
const settings = useSettingsStore()

const EXTENSION_ID = import.meta.env.VITE_EXTENSION_ID || 'dummy_extension_id' // Will be configured later

async function broadcastToExtension() {
  if (!auth.isAuthenticated) return

  try {
    const accessToken = await auth.getAccessToken()
    const idToken = localStorage.getItem('idToken')
    const refreshToken = localStorage.getItem('refreshToken')
    const companyId = settings.company?.id || ''

    // Broadcast auth state to the window so the extension's content script can pick it up
    window.postMessage(
      {
        type: 'TRAMA_SYNC_AUTH_STATE',
        payload: {
          accessToken,
          idToken,
          refreshToken,
          companyId,
        },
      },
      '*',
    )
  } catch (error) {
    console.warn('[App] Failed to broadcast auth state to extension', error)
  }
}

watch(
  () => auth.isAuthenticated,
  (isAuthed) => {
    if (isAuthed) {
      broadcastToExtension()
    }
  },
)

watch(
  () => settings.company,
  (company) => {
    if (company && auth.isAuthenticated) {
      broadcastToExtension()
    }
  },
)

onMounted(async () => {
  await auth.bootstrap()
  if (auth.isAuthenticated) {
    // Optionally fetch company if needed, but that's likely handled in the layout
    broadcastToExtension()
  }
})
</script>

<template>
  <UApp>
    <RouterView />
  </UApp>
</template>
